// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  ICianApiSiteV1GetRegionCitiesRequest,
  TCianApiSiteV1GetRegionCitiesModel,
  IMappers,
  TCianApiSiteV1GetRegionCitiesResponse,
  TCianApiSiteV1GetRegionCitiesResponse_1,
  TCianApiSiteV1GetRegionCitiesResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TCianApiSiteV1GetRegionCitiesModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-region-cities/',
  interserviceAuthEnabled: true,
} as TCianApiSiteV1GetRegionCitiesModel;

export function createCianApiSiteV1GetRegionCitiesModel(
  parameters: ICianApiSiteV1GetRegionCitiesRequest,
): TCianApiSiteV1GetRegionCitiesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICianApiSiteV1GetRegionCitiesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICianApiSiteV1GetRegionCitiesRequest;
}

export async function fetchCianApiSiteV1GetRegionCities<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1GetRegionCitiesOptions<TResponse200, TResponse400>): Promise<
  TCianApiSiteV1GetRegionCitiesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createCianApiSiteV1GetRegionCitiesModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCianApiSiteV1GetRegionCitiesResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TCianApiSiteV1GetRegionCitiesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCianApiSiteV1GetRegionCitiesResponse;
}
